import { render, staticRenderFns } from "./ChoppingTaskTable.vue?vue&type=template&id=391b9604&scoped=true&"
import script from "./ChoppingTaskTable.vue?vue&type=script&lang=js&"
export * from "./ChoppingTaskTable.vue?vue&type=script&lang=js&"
import style0 from "./ChoppingTaskTable.vue?vue&type=style&index=0&id=391b9604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b9604",
  null
  
)

export default component.exports